<app-dialog [(visible)]="visible" title="Skills" [fullscreenOnMobile]="true" class="max-w-[32rem]">
  <ng-template #bodyTemplate>
    @if(loading()) {
    <div class="py-8 text-center text-gray-500">Loading...</div>
    } @else {
    <!-- Breadcrumb trail -->
    <div class="flex flex-wrap items-center gap-1 text-sm text-gray-600 mb-3 min-h-[1.5rem]">
      @for (seg of breadcrumbSegments(); track seg; let i = $index) {
      <app-button variant="text" severity="contrast" [label]="seg + ' /'"
        (clicked)="navigateToBreadcrumb(i)"
        class="hover:text-gray-900 hover:underline focus:outline-none focus:underline rounded px-0.5" />
      }
    </div>
    <!-- Single-level list -->
    <div
      class="manage-skills-list min-h-[200px] max-h-[50vh] overflow-y-auto overflow-x-hidden border border-gray-200 rounded-lg p-2">
      @if(directChildren().length === 0) {
      <div class="py-8 text-center text-gray-500 text-sm">No skills yet. Add a skills ZIP to get started.</div>
      } @else {
      @for (node of directChildren(); track node.path) {
      <div class="flex items-center gap-2 py-1 group" [class.cursor-pointer]="node.isFolder"
        [class.cursor-default]="!node.isFolder" (click)="node.isFolder && navigateToFolder(node.name)">
        <app-icon [type]="node.isFolder ? 'folder' : 'file-text'" [source]="'lucide'" [size]="'default'"
          class="flex-shrink-0 text-gray-500" />
        <span class="flex-1 min-w-0 truncate text-sm" [title]="node.name">{{ node.name }}</span>
        <app-menu #rowMenu [items]="getMenuItemsForNode(node)" (itemSelected)="rowMenu.hide()">
          <app-button variant="ghost" severity="contrast" icon="pi pi-ellipsis-v" iconSource="primeng" [iconSize]="'sm'"
            (clicked)="$event.stopPropagation(); openDeleteMenu($event, node, rowMenu)"
            class="opacity-0 group-hover:opacity-100 flex-shrink-0" />
        </app-menu>
      </div>
      }
      }
    </div>
    }
  </ng-template>
  <ng-template #footerTemplate>
    <div class="flex justify-end w-full">
      <app-button label="Add skills" variant="filled" severity="primary" (clicked)="openAddSkillsDialog()" />
    </div>
  </ng-template>
</app-dialog>

<!-- File preview dialog -->
<app-dialog [visible]="previewDialogVisible()" (closed)="closePreviewDialog()"
  [title]="previewFile()?.filename ?? 'Preview'" [fullscreenOnMobile]="true" class="max-w-[56rem]">
  <ng-template #bodyTemplate>
    @if(previewLoading()) {
    <div class="flex items-center justify-center py-16">
      <i class="pi pi-spinner pi-spin text-3xl text-gray-500"></i>
    </div>
    } @else if(previewFile()) {
    <div class="h-[60vh] overflow-auto bg-gray-50 rounded-lg">
      <app-multi-format-preview [documentId]="previewFile()!.url" [file]="previewFile()!" [loading]="previewLoading()">
      </app-multi-format-preview>
    </div>
    }
  </ng-template>
</app-dialog>

<!-- Add skills dialog -->
<app-dialog [visible]="addSkillsDialogVisible()" (closed)="closeAddSkillsDialog()" title="Add skills"
  [fullscreenOnMobile]="true" class="max-w-[28rem]">
  <ng-template #bodyTemplate>
    <p class="text-sm text-gray-600 mb-3">Upload a ZIP file containing your skills (max 1 file).</p>
    <app-file-drop [fileTypes]="['.zip']" [maxFiles]="1" [maxFileSize]="104857600" [showDesc]="true"
      (uploadData)="onUploadData($event)" />
  </ng-template>
  <ng-template #footerTemplate>
    <div class="flex justify-end gap-2">
      <app-button label="Cancel" variant="outlined" severity="contrast" (clicked)="closeAddSkillsDialog()" />
      <app-button label="Upload" variant="filled" severity="primary" (clicked)="submitAddSkills()"
        [loading]="uploading()" [disabled]="uploadFiles().length === 0" />
    </div>
  </ng-template>
</app-dialog>